import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo/logo.png"; // GLabs logo
import CustomCursor from "../components/CustomCursor";
import NotFoundImage from "../assets/notfound/notfound.png"; // Add your 404 illustration here
import useSEO from '../hooks/useSEO';

const NotFound = () => {
  // Apply SEO for 404 page
  useSEO({
    title: "Page Not Found | GLabs Automator",
    description: "The page you are looking for doesn't exist. Return to GLabs Automator homepage to automate your AI content creation workflow.",
    canonical: "https://glabsautomator.com/404"
  });

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 font-inter overflow-x-hidden flex flex-col">
      
      {/* Custom Cursor */}
      <CustomCursor />

      {/* Navigation/Header */}
      <header className="border-b border-gray-200 dark:border-gray-800 py-4 md:py-6">
        <div className="container mx-auto ms-12 px-4 flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <img src={Logo} alt="GLabs Automator" className="h-10 md:h-12 w-auto" />
            <span className="text-xl md:text-2xl font-bold text-gray-900 dark:text-white">
              <span className="text-blue-500">GLabs</span>{" "}
              <span className="text-green-500">Automator</span>
            </span>
          </Link>
        </div>
      </header>

      {/* Main Content (Centered) */}
      <main className="flex-grow flex items-center justify-center px-4">
        <div className="flex flex-col items-center text-center space-y-6">
          {/* Image */}
          <img
            src={NotFoundImage}
            alt="404 Illustration"
            className="w-full max-w-xs md:max-w-sm"
          />

          {/* Text */}

          <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 dark:text-gray-200">
            Oops! Page Not Found
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-md">
            The page you are looking for doesn’t exist or may have been moved.
          </p>

          {/* Back to Home */}
          <Link
            to="/"
            className="inline-block mt-4 px-6 py-3 bg-gradient-to-r from-purple-800 to-cyan-500 text-white rounded-lg font-semibold hover:opacity-70 transition-all"
          >
            Back to Home
          </Link>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
